import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { INTEL_LEADERBOARD_LAYOUT_ID, INTEL_LEADERBOARD_LAYOUT_TEMPLATE_ID } from '../tokens';
import { INTEL_LEADERBOARD_LAYOUT } from './IntelLeaderboard';

export const INTEL_LEADERBOARD_LAYOUT_SPEC: LayoutSpec = {
  templateId: INTEL_LEADERBOARD_LAYOUT_TEMPLATE_ID,
  label: 'Leaderboard',
  id: INTEL_LEADERBOARD_LAYOUT_ID,
  dockViewLayout: INTEL_LEADERBOARD_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
